import { render, staticRenderFns } from "./Strip.vue?vue&type=template&id=425cf6aa&"
import script from "./Strip.vue?vue&type=script&lang=js&"
export * from "./Strip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports